import React from 'react';
import ProjectCard from './ProjectCard';
import streetProgSessions from '../../assets/img/streetprog-sessions.png';
import vbScoreScore from '../../assets/img/vbscore-score.png';

const projects = [
    {
        title: 'StreetProg',
        context: 'Projet personnel',
        description: 'PWA de programmation et suivi de séances sportives, avec gestion des exercices, sessions, progression et notes.',
        stack: ['Angular', 'PWA', 'API REST'],
        link: 'https://streetprog.codymacedo.fr/',
        previewImage: streetProgSessions,
        previewAlt: 'Capture StreetProg affichant la liste des séances'
    },
    {
        title: 'VB Score',
        context: 'Projet personnel',
        description: 'Scoreboard volley rapide en PWA, pensé pour gérer les scores de match depuis mobile.',
        stack: ['Angular', 'PWA', 'Scoreboard'],
        link: 'https://vbscore.codymacedo.fr/',
        previewImage: vbScoreScore,
        previewAlt: 'Capture VB Score affichant le tableau de score volley'
    },
    {
        title: 'Applications métier Groupe BIR',
        context: 'Projet professionnel',
        description: 'Développement full-stack de fonctionnalités métier, avec intégration front-end, logique back-end et maintenance applicative.',
        stack: ['Angular', '.NET', '4D']
    },
    {
        title: 'Écosystème mobile Kiwip',
        context: 'Projet professionnel',
        description: 'Applications Android et montre connectée reliées à une API Symfony pour suivre et exploiter des données côté mobile.',
        stack: ['Android', 'Kotlin', 'Symfony']
    },
    {
        title: 'Applications web et API',
        context: 'Projet professionnel',
        description: 'Conception d’API et d’interfaces web autour de besoins métiers, avec persistance relationnelle ou documentaire selon le contexte.',
        stack: ['Symfony', 'API Platform', 'MongoDB']
    }
];

const Projects = () => {
    return (
        <section className="projects" id="projects" aria-labelledby="projects-title">
            <div className="container">
                <div className="header-projects">
                    <h1 id="projects-title">Projets</h1>
                </div>
                <div className="projects-intro">
                    <p>Quelques réalisations personnelles et professionnelles représentatives de mon travail en web, mobile et back-end.</p>
                </div>
                <div className="projects-container">
                    {projects.map((project) => (
                        <ProjectCard key={project.title} {...project} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Projects;
